import React, { useEffect, useRef, useState } from 'react';
import { Modal } from '@hagerty/react-components';
import { Play64 } from '@hagerty/icons';

import styles from './VideoModal.module.scss';

type Props = {
  thumbnail: string;
  children?: JSX.Element;
};

export const VideoModal: React.FC<Props> = ({ children, thumbnail }): JSX.Element => {
  const [open, setOpen] = useState(false);
  const videoImage = { backgroundImage: `url(${thumbnail})` };
  const ref = useRef(null);

  useEffect(() => {
    const listener = (event: any) => {
      if (
        event.target == ref?.current.nextSibling ||
        event.target.closest('.button-close') ||
        event.target.classList.contains('modal__container')
      )
        handleClose();
    };
    ref?.current.nextSibling.addEventListener('click', listener);
    return () => {
      ref?.current.nextSibling.removeEventListener('click', listener);
    };
  }, [ref]);

  const handleOpen = (event, isNotClick = false) => {
    if (event?.target.id !== ref?.current.id || isNotClick) ref?.current.click();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    ref?.current.nextSibling.click();
  };

  return (
    <div className={styles.videoModal}>
      <div
        className={styles.thumbnail}
        style={videoImage}
        onClick={handleOpen}
        data-cy="video-modal"
        id={thumbnail}
        ref={ref}
      >
        <div className={styles.play}>
          <Play64 />
        </div>
      </div>
      <Modal id={thumbnail} isAnimated>
        {React.cloneElement(children, { open: open })}
      </Modal>
    </div>
  );
};
